<panel width="600">
	<h1>{{ header | translate }}</h1>
	<section scrollable>
		@if (questionnaireId && orderLines) {
			<questionnaire [questionnaireId]="questionnaireId"
						   [orderLines]="orderLines"
						   [showCategoryDetails]="false"
						   [displayAsForm]="displayAsForm"
						   [editable]="true" />
		}
	</section>
	@if (displayAsForm) {
		<section>
			<button confirm [ignoreValidation]="true" (click)="saveReplies()">{{ 'general.save' | translate }}</button>
		</section>
	}
</panel>
